// tanstack
import { createFileRoute, Outlet } from '@tanstack/react-router';

// components
import ErrorBoundary from '@/routes/-ErrorBoundary';

export const Route = createFileRoute('/$accountId/_admin/devices')({
  component: Outlet,
  errorComponent: ErrorBoundary,
});
